import styled from "styled-components";

const TagButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default TagButtonContainer;
